// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__1JNs2","hideMenu":"Menu_hideMenu__3AjgB","links":"Menu_links__LQVlq","link":"Menu_link__1hJ0p"};